import { createTheme } from '@mui/material/styles';

declare module '@mui/material/styles' {
    interface Palette {
      border: Palette['primary'];
      buttonPrimary: Palette['primary'];
      buttonSecondary: Palette['primary'];
      backgroundPrimary: Palette['primary'];
    }
  
    interface PaletteOptions {
      border?: PaletteOptions['primary'];
      buttonPrimary?: PaletteOptions['primary'];
      buttonSecondary?: PaletteOptions['primary'];
      backgroundPrimary?: PaletteOptions['primary'];
    }
  }
  declare module '@mui/material/Button' {
    interface ButtonPropsColorOverrides {
      buttonPrimary: true;
    }
  }

const theme = createTheme({
  palette: {
    backgroundPrimary: {
        main: '#FAFAFA',
    },
    border:{
        main: '#EFF0F0'
    },
    buttonPrimary:{
        main: '#FAB306'
    },
    buttonSecondary:{
        main: '#EFF0F0'
    }
  },
  typography: {
    fontFamily: 'Manrope, sans-serif',

    h3: {
      fontWeight: 700, // Bold
      fontSize: '24px',
      lineHeight: '32px',
    },

    body1: {
      fontWeight: 600, // Semibold
      fontSize: '16px',
      lineHeight: '24px',
    },

    body2: {
      fontWeight: 500, // Medium
      fontSize: '16px',
      lineHeight: '24px',
    },

    subtitle1: {
      fontWeight: 500,
      fontSize: '14px',
      lineHeight: '16px',
    },

    caption: {
      fontWeight: 500,
      fontSize: '12px',
      lineHeight: '14px',
    },
  },
});
export default theme;
